import * as jobsID from '../data/jobID'
export function getPassiveSkillsBonuses(
	newBonuses,
	inventory,
	baseLevel,
	job,
	getSkillLevel
) {
	//Increase HP Recovery
	newBonuses['bHPrecovRate'] =
		(newBonuses['bHPrecovRate'] ? newBonuses['bHPrecovRate'] : 0) +
		(2 * getSkillLevel('SM_RECOVERY')) / 10
	if (getSkillLevel('SM_RECOVERY')) {
		newBonuses['bAddItemHealRate'] = newBonuses['bAddItemHealRate']
			? newBonuses['bAddItemHealRate']
			: []
		let index = 0
		index = newBonuses['bAddItemHealRate'].findIndex((bon) => bon.ID === 0)
		if (~index)
			newBonuses['bAddItemHealRate'][index] = {
				ID: 0,
				Rate:
					newBonuses['bAddItemHealRate'][index].Rate +
					10 * getSkillLevel('SM_RECOVERY'),
			}
		else
			newBonuses['bAddItemHealRate'].push({
				ID: 0,
				Rate: 10 * getSkillLevel('SM_RECOVERY'),
			})
	}
	//Increase SP Recovery
	newBonuses['bSPrecovRate'] =
		(newBonuses['bSPrecovRate'] ? newBonuses['bSPrecovRate'] : 0) +
		(2 * getSkillLevel('MG_SRECOVERY')) / 10
	if (getSkillLevel('MG_SRECOVERY')) {
		newBonuses['bAddItemSPHealRate'] = newBonuses['bAddItemSPHealRate']
			? newBonuses['bAddItemSPHealRate']
			: []
		let index = 0
		index = newBonuses['bAddItemSPHealRate'].findIndex(
			(bon) => bon.ID === 0
		)
		if (~index)
			newBonuses['bAddItemSPHealRate'][index] = {
				ID: 0,
				Rate:
					newBonuses['bAddItemSPHealRate'][index].Rate +
					10 * getSkillLevel('MG_SRECOVERY'),
			}
		else
			newBonuses['bAddItemSPHealRate'].push({
				ID: 0,
				Rate: 10 * getSkillLevel('MG_SRECOVERY'),
			})
	}
	//Music Lessons
	newBonuses['bMaxSPrate'] =
		(newBonuses['bMaxSPrate'] ? newBonuses['bMaxSPrate'] : 0) +
		getSkillLevel('BA_MUSICALLESSON')
	//Dance Lessons
	newBonuses['bMaxSPrate'] =
		(newBonuses['bMaxSPrate'] ? newBonuses['bMaxSPrate'] : 0) +
		getSkillLevel('DC_DANCINGLESSON')
	//Meditatio
	newBonuses['bMaxSPrate'] =
		(newBonuses['bMaxSPrate'] ? newBonuses['bMaxSPrate'] : 0) +
		getSkillLevel('HP_MEDITATIO')
	newBonuses['bSPrecovRate'] =
		(newBonuses['bSPrecovRate'] ? newBonuses['bSPrecovRate'] : 0) +
		3 * getSkillLevel('HP_MEDITATIO')
	newBonuses['bHealPower'] =
		(newBonuses['bHealPower'] ? newBonuses['bHealPower'] : 0) +
		2 * getSkillLevel('HP_MEDITATIO')
	//Kaina
	newBonuses['bMaxSP'] =
		(newBonuses['bMaxSP'] ? newBonuses['bMaxSP'] : 0) +
		getSkillLevel('SL_KAINA')

	//Faith
	newBonuses['bMaxHP'] =
		(newBonuses['bMaxHP'] ? newBonuses['bMaxHP'] : 0) +
		200 * getSkillLevel('CR_TRUST')

	switch (inventory['Right_Hand'].SubType) {
		case '1hSword':
			//Sword Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				4 * getSkillLevel('SM_SWORD')
			//Axe Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('AM_AXEMASTERY')
			break
		case 'Dagger':
			//Sword Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				4 * getSkillLevel('SM_SWORD')
			break
		case '2hSword':
			//Two-Handed Sword Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				4 * getSkillLevel('SM_TWOHAND')
			break
		case 'Bow':
			//Vulture's Eye
			newBonuses['bHit'] =
				(newBonuses['bHit'] ? newBonuses['bHit'] : 0) +
				getSkillLevel('AC_VULTURE')
			newBonuses['bAtkRange'] =
				(newBonuses['bAtkRange'] ? newBonuses['bAtkRange'] : 0) +
				getSkillLevel('AC_VULTURE')
			break
		case '1hSpear':
		case '2hSpear':
			//Spear Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				(4 + (getSkillLevel('KN_RIDING') ? 1 : 0)) *
					getSkillLevel('KN_SPEARMASTERY')
			break
		case 'Book':
			//Study
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('SA_ADVANCEDBOOK')
			newBonuses['bAspdRate'] =
				(newBonuses['bAspdRate'] ? newBonuses['bAspdRate'] : 0) +
				getSkillLevel('SA_ADVANCEDBOOK') / 2
			break
		case '1hAxe':
		case '2hAxe':
			//Axe Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('AM_AXEMASTERY')
			break
		case 'Mace':
			//Mace Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('PR_MACEMASTERY')
			newBonuses['bCritical'] =
				(newBonuses['bCritical'] ? newBonuses['bCritical'] : 0) +
				getSkillLevel('PR_MACEMASTERY')
			break
		case 'Knuckle':
		case 'Fist':
		case 0:
			//Iron Fists
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('MO_IRONHAND')
			break
		case 'Katar':
			//Katar Mastery
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('AS_KATAR')
			break
		case 'Musical':
			//Music Lessons
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('BA_MUSICALLESSON')
			newBonuses['bAspdRate'] =
				(newBonuses['bAspdRate'] ? newBonuses['bAspdRate'] : 0) +
				getSkillLevel('BA_MUSICALLESSON')
			break
		case 'Whip':
			//Dance Lessons
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('DC_DANCINGLESSON')
			newBonuses['bCritical'] =
				(newBonuses['bCritical'] ? newBonuses['bCritical'] : 0) +
				getSkillLevel('DC_DANCINGLESSON')
			break
		case 'Revolver':
		case 'Rifle':
		case 'Shotgun':
		case 'Gatling':
		case 'Grenade':
			//Single Action
			newBonuses['bHit'] =
				(newBonuses['bHit'] ? newBonuses['bHit'] : 0) +
				2 * getSkillLevel('GS_SINGLEACTION')
			newBonuses['bAspdRate'] =
				(newBonuses['bAspdRate'] ? newBonuses['bAspdRate'] : 0) +
				Math.floor((getSkillLevel('GS_SINGLEACTION') + 1) / 2)
			//Snake Eyes
			newBonuses['bHit'] =
				(newBonuses['bHit'] ? newBonuses['bHit'] : 0) +
				getSkillLevel('GS_SNAKEEYE')
			newBonuses['bAtkRange'] =
				(newBonuses['bAtkRange'] ? newBonuses['bAtkRange'] : 0) +
				getSkillLevel('GS_SNAKEEYE')
			break
		default:
			break
	}
	//Weaponry Research
	newBonuses['bMastery'] =
		(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
		2 * getSkillLevel('BS_WEAPONRESEARCH')
	newBonuses['bHitRate'] =
		(newBonuses['bHitRate'] ? newBonuses['bHitRate'] : 0) +
		2 * getSkillLevel('BS_WEAPONRESEARCH')

	let enemyRace = 0 //TODO
	switch (enemyRace) {
		case 'RC_Demon':
		case 'RC_Undead':
			//Demon Bane
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				3 * getSkillLevel('AL_DEMONBANE')
			//Divine Protection
			/**
			 * irowiki's note : The defense raise is affected by Base Level.
			 * source Rathena code:
			 * 	(skill = pc_checkskill(tsd, AL_DP)) > 0)
			 * 	 vit_def += (int)(((float)tsd->status.base_level / 25.0 + 3.0) * skill + 0.5);
			 */
			newBonuses['bDef2'] =
				(newBonuses['bDef2'] ? newBonuses['bDef2'] : 0) +
				Math.floor((baseLevel / 25 + 3) * getSkillLevel('AL_DP') + 0.5)
			break
		case 'RC_Brute':
		case 'RC_Insect':
			//Beast Bane
			newBonuses['bMastery'] =
				(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
				4 * getSkillLevel('HT_BEASTBANE')
			break
		default:
			break
	}
	//Dragonology
	newBonuses['bInt'] =
		(newBonuses['bInt'] ? newBonuses['bInt'] : 0) +
		Math.floor((1 + getSkillLevel('SA_DRAGONOLOGY')) / 2)
	//init new array if bAddRace is not used yet
	newBonuses['bAddRace'] = newBonuses['bAddRace']
		? newBonuses['bAddRace']
		: []
	newBonuses['bAddRace']['RC_Dragon'] =
		(newBonuses['bAddRace']['RC_Dragon']
			? newBonuses['bAddRace']['RC_Dragon']
			: 0) +
		4 * getSkillLevel('SA_DRAGONOLOGY')
	//init new array if bAddRace is not used yet
	newBonuses['bMagicAddRace'] = newBonuses['bMagicAddRace']
		? newBonuses['bMagicAddRace']
		: []
	newBonuses['bMagicAddRace']['RC_Dragon'] =
		(newBonuses['bMagicAddRace']['RC_Dragon']
			? newBonuses['bMagicAddRace']['RC_Dragon']
			: 0) +
		2 * getSkillLevel('SA_DRAGONOLOGY')
	//init new array if bAddRace is not used yet
	newBonuses['bSubRace'] = newBonuses['bSubRace']
		? newBonuses['bSubRace']
		: []
	newBonuses['bSubRace']['RC_Dragon'] =
		(newBonuses['bSubRace']['RC_Dragon']
			? newBonuses['bSubRace']['RC_Dragon']
			: 0) +
		4 * getSkillLevel('SA_DRAGONOLOGY')

	//Enlarge Weight Limit
	newBonuses['bAddMaxWeight'] =
		(newBonuses['bAddMaxWeight'] ? newBonuses['bAddMaxWeight'] : 0) +
		200 * getSkillLevel('MC_INCCARRY')
	//Hilt Binding
	newBonuses['bStr'] =
		(newBonuses['bStr'] ? newBonuses['bStr'] : 0) +
		getSkillLevel('BS_HILTBINDING')
	newBonuses['bMastery'] =
		(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
		4 * getSkillLevel('BS_HILTBINDING')
	//Skin Tempering
	//init new array if bAddRace is not used yet
	newBonuses['bSubEle'] = newBonuses['bSubEle'] ? newBonuses['bSubEle'] : []
	newBonuses['bSubEle']['Ele_Neutral'] =
		(newBonuses['bSubEle']['Ele_Neutral']
			? newBonuses['bSubEle']['Ele_Neutral']
			: 0) + getSkillLevel('BS_SKINTEMPER')
	newBonuses['bSubEle']['Ele_Fire'] =
		(newBonuses['bSubEle']['Ele_Fire']
			? newBonuses['bSubEle']['Ele_Fire']
			: 0) +
		4 * getSkillLevel('BS_SKINTEMPER')
	//Peco Peco Ride
	newBonuses['bAddMaxWeight'] =
		(newBonuses['bAddMaxWeight'] ? newBonuses['bAddMaxWeight'] : 0) +
		(getSkillLevel('KN_RIDING') ? 1000 : 0)
	//Improve Dodge
	newBonuses['bFlee'] =
		(newBonuses['bFlee'] ? newBonuses['bFlee'] : 0) +
		3 * getSkillLevel('TF_MISS')
	if (job & jobsID.EAJL_2)
		newBonuses['bFlee'] =
			(newBonuses['bFlee'] ? newBonuses['bFlee'] : 0) +
			getSkillLevel('TF_MISS')
	//Flee
	newBonuses['bFlee'] =
		(newBonuses['bFlee'] ? newBonuses['bFlee'] : 0) +
		Math.floor((getSkillLevel('MO_DODGE') * 3) / 2)

	//Owl's Eye
	newBonuses['bDex'] =
		(newBonuses['bDex'] ? newBonuses['bDex'] : 0) + getSkillLevel('AC_OWL')
	//Intimidate
	newBonuses['bAspdRate'] =
		(newBonuses['bAspdRate'] ? newBonuses['bAspdRate'] : 0) +
		getSkillLevel('RG_INTIMIDATE')
	//Solar, Lunar and Stellar Shadow
	newBonuses['bAspdRate'] =
		(newBonuses['bAspdRate'] ? newBonuses['bAspdRate'] : 0) +
		(getSkillLevel('SG_DEVIL') ? 1 + getSkillLevel('SG_DEVIL') : 0)
	//Dagger Throwing Practice
	let activeSkill = 0 //TODO
	//NJ_SYURIKEN = Throw Shuriken
	//NJ_KUNAI = Throw Kunai
	//NJ_HUUMA = Throw Huuma Shuriken
	if (
		activeSkill === 'NJ_SYURIKEN' ||
		activeSkill === 'NJ_KUNAI' ||
		activeSkill === 'NJ_HUUMA'
	)
		newBonuses['bMastery'] =
			(newBonuses['bMastery'] ? newBonuses['bMastery'] : 0) +
			3 * getSkillLevel('NJ_TOBIDOUGU')

	//Kihop
	let partyMembers = 0 //TODO
	newBonuses['bAtkRate'] =
		(newBonuses['bAtkRate'] ? newBonuses['bAtkRate'] : 0) +
		partyMembers * (2 * getSkillLevel('ATK_POWERC_OWL'))

	// return newBonuses
}
